import { Circle, Rect, Shape, Text } from "react-konva"
import { StaticObj, TextObj } from "../../interface/StaticObject"

export const StaticObject = ({ object }: { object: StaticObj }) => {
    // console.log(object)
    return (
        <RenderObject object={object} />
    )
}
export const TextObject = ({ text }: { text: TextObj }) => {

    return (
        <>
            <Text
                width={typeof text.width === 'string' ? parseInt(text.width) : text.width}
                align={text.align ? text.align : "center"}
                verticalAlign={text.verticalAlign ? text.verticalAlign : "middle"}
                x={typeof text.x === 'string' ? parseInt(text.x) : text.x}
                y={typeof text.y === 'string' ? parseInt(text.y) : text.y}
                fontSize={typeof text.fontSize === 'string' ? parseInt(text.fontSize) : text.fontSize}
                fill={text.fill}
                text={text.text}
            />
        </>
    )
}

// const GetPoints = (ctxs: { x: number, y: number }[]): number[] => {
//     const points: number[] = [];
//     ctxs.forEach(ctx => {
//         points.push(typeof ctx.x === 'string' ? parseInt(ctx.x) : ctx.x);
//         points.push(typeof ctx.y === 'string' ? parseInt(ctx.y) : ctx.y);
//     });
//     return points;
// };


const RenderObject = ({ object }: { object: StaticObj }) => {
    // console.log(object)
    // object.x = typeof object.x === 'string' ? parseInt(object.x) : object.x;
    // object.y = typeof object.y === 'string' ? parseInt(object.y) : object.y;

    switch (object.figureType) {
        case 'shape':
            return <Shape
                strokeWidth={object.strokeWidth}
                stroke={object.stroke}
                x={object.x}
                y={object.y}
                rotation={typeof object.rotation === 'string' ? parseInt(object.rotation) : object.rotation}
                width={object.width}
                fill={object.fill}
                sceneFunc={(context, shape) => {
                    context.beginPath();
                    object.ctxs.forEach(ctx => {
                        switch (ctx.type) {
                            case 'move':
                                return context.moveTo(ctx.x, ctx.y);
                            case 'line':
                                return context.lineTo(ctx.x, ctx.y);
                            case 'curve':
                                return context.quadraticCurveTo(ctx.cpx, ctx.cpy, ctx.x, ctx.y)
                            default: return null;
                        }
                    });
                    context.closePath();
                    context.fillStrokeShape(shape);

                }}
            />;
        // case 'line': return <Line
        //     x={object.x}
        //     y={object.y}
        //     points={GetPoints(object.ctxs)}
        //     tension={1}
        //     rotation={typeof object.rotation === 'string' ? parseInt(object.rotation) : object.rotation}
        //     strokeWidth={object.strokeWidth}
        //     // closed
        //     lineCap="round"
        //     stroke={object.fill}
        // />

        case 'line': return <Shape
            strokeWidth={object.width}
            stroke={object.fill}
            x={object.x}
            y={object.y}
            dash={[10, 2]}
            rotation={typeof object.rotation === 'string' ? parseInt(object.rotation) : object.rotation}
            // width={object.width}
            // fill={object.fill}
            sceneFunc={(context, shape) => {
                context.beginPath();
                context.moveTo(object.ctxs[0].x, object.ctxs[0].y)
                context.quadraticCurveTo(object.ctxs[1].x, object.ctxs[1].y, object.ctxs[2].x, object.ctxs[2].y)
                // object.ctxs.forEach(ctx => {
                //     ctx.x, ctx.y;
                //     // switch (ctx.type) {
                //     //     case 'move':
                //     //         return context.moveTo(ctx.x, ctx.y);
                //     //     case 'line':
                //     //         return context.lineTo(ctx.x, ctx.y);
                //     //     case 'curve':
                //     //         return context.quadraticCurveTo(ctx.cpx, ctx.cpy, ctx.x, ctx.y)
                //     //     default: return null;
                //     // }
                // });
                // context.closePath();
                context.fillStrokeShape(shape);

            }}
        />;
        case 'circle':
            return <Circle
                x={object.x}
                y={object.y}
                radius={object.width}
                strokeWidth={object.strokeWidth}
                stroke={object.stroke}
                fill={object.fill}
            />
        case 'rect':
            return <Rect
                // .posX === 'string' ? parseInt(data.posX) : data.posX
                x={object.x}
                y={object.y}
                rotation={typeof object.rotation === 'string' ? parseInt(object.rotation) : object.rotation}
                width={typeof object.ctxs[0].x === 'string' ? parseInt(object.ctxs[0].x) : object.ctxs[0].x}
                height={typeof object.ctxs[0].y === 'string' ? parseInt(object.ctxs[0].y) : object.ctxs[0].y}
                fill={object.fill}
                stroke={object.stroke}
                strokeWidth={object.strokeWidth}
            />
        default:
            return null;
    }
}


